// extracted by mini-css-extract-plugin
export default {"statisticsHeader":"statisticspage_statisticsHeader__zmPpn","mainContent":"statisticspage_mainContent__qx4lL"};